import './styles.css';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Plus from '../../images/icons/plus.svg';
import Avatar from '../../../../images/face-0.jpg';
import ModalForm from './components/ModalForm/ModalForm';
import Table from '../../../../components/Table/index';
import ModalPerson from './components/ModalPerson/ModalPerson';

const PublicInGral = ({ people, specialties }, context) => {
    //Notifier
    const notifier = context.notifier;

    //STATE
    const [modalState, setModalState] = React.useState(false);
    const [modalPerson, setModalPerson] = React.useState(false);
    const [personData, setPersonData] = React.useState({});
    const [editState, setEditState] = React.useState(false);
    const [editData, setEditData] = React.useState({});

    //API CALLS
    const api = context.api;
    React.useEffect(() => {
        api.people.get(0, 50, '@PeopleWithoutMembership', { 'membership[exists]': false, 'user[exists]': false});
        api.specialties.get();
    }, [api]);

    //MODAL HANDLER
    const closeModal = () => {
        setModalState(false);
        editState && setEditState(false);
        editState && setEditData({});
    };

    //TABLE METHOD
    const loadData = tableState => {
        api.people.get(
            tableState.page,
            tableState.pageSize,
            '@PeopleWithoutMembership',
            { ...tableState.filters, 'membership[exists]': false, 'user[exists]':false }
        );
    };

    //FORM HANDLERS
    const handleFormData = (method, id, data, photo, resume) => {
        if (method === 'edit') {
            api.people.edit(id, data, '@Edit.Public.Gral', photo, null, resume).then(() => {
                closeModal();
                notifier.success(`Los datos de ${data.name} se han actualizado correctamente.`);
            });
        } else {
            api.people.create(data, '@Create.Public.Gral', photo, null, resume).then(() => {
                closeModal();
                notifier.success(`Se a registrado a ${data.name} de manera exitosa.`);
            });
        }
    };

    //COLUMNS HANDLERS
    const removePerson = person => {
        if (window.confirm(`¿Estas seguro de eliminar a ${person.name}`)) {
            api.people.delete(person.id).then(() => notifier.success(`${person.name} ha sido eliminado.`));
        }
    };
    const editPerson = person => {
        setModalState(true);
        setEditState(true);
        setEditData(person);
    };


    //TABLE CONFIG
    const columns = [
        {
            name: 'Acciones',
            accessor: (person) => (
                <div className="actions">
                    <button className="btn btn-xs btn-primary" onClick={(e) => {
                        e.stopPropagation();
                        editPerson(person)
                    }}>
                        <i className="ti-pencil"></i>
                    </button>
                    <button className="btn btn-xs btn-danger" onClick={(e) => {
                        e.stopPropagation();
                        removePerson(person)
                    }}>
                        <li className="ti-trash"></li>
                    </button>
                </div>
            )
        },
        {
            name: 'Fotografía',
            accessor: (person) => <img className="user-profile-photo" src={person.photo ? api.appFiles.getUrl(person.photo.id) : Avatar} alt="Foto de perfil" />
        },
        {
            name: 'Título',
            accessor: 'title'
        },
        {
            name: 'Nombre',
            accessor: 'name',
            id: 'name',
            filterable: true,
        },
        {
            name: 'Apellidos',
            id: 'patLastName',
            filterable: true,
            accessor: (person) => `${person.patLastName} ${person.matLastName}`
        },
        {
            name: 'Especialidad',
            id: 'specialty.name',
            filterable: true,
            accessor: (person) => person.specialty ? person.specialty.name : ''
        },
        {
            name: 'Residencia',
            id: 'residence',
            filterable: true,
            accessor: (person) => person.residence ? `${person.residence}${person.city ? `, ${person.city}.` : ''}` : 'Sin información',
        },
        {
            name: 'Email',
            id: 'email',
            filterable: true,
            accessor: 'email'
        }
    ];


    return (
        <div className="PublicInGral">
            <h3>Público en general</h3>
            <div className="init-actions">
                <a href={api.people.exportUrl({}, false, 'xlsx', 'Público en general')}>
                    <button
                        className='btn btn-info btn-fill btn-magnify download-report'>
                        <span className='btn-label'>Descargar excel</span>
                    </button>
                </a>
                <a href={api.people.exportUrl({}, false, 'pdf', 'Público en general')}>
                    <button
                        className='btn btn-info btn-fill btn-magnify download-report'>
                        <span className='btn-label'>Descargar PDF</span>
                    </button>
                </a>

                <button className="addUser" onClick={() => setModalState(true)}>
                    Añadir persona
                <img src={Plus} alt="Añadir usuario" />
                </button>
            </div>

            {
                modalState &&
                <ModalForm
                    api={api}
                    notifier={notifier}
                    workData={specialties}
                    handleFormData={handleFormData}
                    modalState={modalState}
                    editState={editState}
                    editData={editData}
                    onModalHide={closeModal}
                />
            }
            {
                modalPerson &&
                <ModalPerson
                    api={api}
                    personData={personData}
                    modalState={modalPerson}
                    onModalHide={() => setModalPerson(false)}
                />
            }

            <Table
                data={people}
                columns={columns}
                loadData={loadData}
                trProps={(row) => ({ onClick: () => { setModalPerson(true); setPersonData(row) } })}
            />
        </div>
    );
};


//Context and Redux;
PublicInGral.contextTypes = {
    api: PropTypes.object,
    notifier: PropTypes.object
};
const mapStateToProps = ({ api: { people = [], specialties = [] } }) => {
    return { people, specialties };
};
export default connect(mapStateToProps)(PublicInGral); 


// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/scenes/PublicInGral/PublicInGral.jsx